/**
 * Session parameters.
 *
 * Context: OMC runs 24/7 on shared workstations in the ops room. Hence
 * sessionStorage (closing the browser drops the session) plus an idle
 * timeout, rather than the long-lived session a normal app would use.
 *
 * These are proposed defaults — confirm with information security
 * (question C9 in docs/02-CAU-HOI-CAN-TRA-LOI.md).
 */

/** Absolute session lifetime: one duty shift plus handover. */
export const ABSOLUTE_SESSION_MS = 12 * 60 * 60 * 1000

/** Sign out automatically after this much inactivity. */
export const IDLE_TIMEOUT_MS = 60 * 60 * 1000

/** Warn this long before the idle timeout fires. */
export const IDLE_WARNING_MS = 2 * 60 * 1000

/** Minimum password length. Real enforcement belongs on the server. */
export const MIN_PASSWORD_LENGTH = 12
